<template>
  <page-wrap>
    <grid
      ref="grid"
      :config="gridConfig"
      @handleCustomButtonGrid="handlerCreateTD"
    />
    <editor :config="{ id: gridConfig.id }" />
  </page-wrap>
</template>

<script>
import gridConfig from './GridConfig.js'
import { waitValue } from '@/utils/promises'
import { ServiceRepairTearDowns } from '@/services/RepairTearDowns'

export default {
  name: 'RepairExchangeTd',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'RFQRepairTd' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handlerCreateTD ({ row, button }) {
      let grid = null
      return this.getGrid()
        .then((g) => {
          grid = g
          grid.setLoading(true)
          return grid
        })
        .then(() => {
          return this.requestCreteTD(row)
        })
        .then(() => {
          return grid.refresh()
        })
        .then(() => {
          grid.actionRowButton({ type: 'edit', row })
        })
        .finally(() => {
          grid.setLoading(false)
        })
    },
    requestCreteTD (dataRow) {
      let data = {
        rfqid: dataRow.rfqid,
        partID: dataRow.partID,
        partSN: dataRow.partSN,
        entryDate: new Date()
      }
      return ServiceRepairTearDowns
        .post(data)
        .catch((err) => {
          this.requestErrorHandler(err)
          throw err
        })
    }
  }
}
</script>
